import { render, staticRenderFns } from "./LixeiraTable.vue?vue&type=template&id=0824d800&scoped=true&"
import script from "./LixeiraTable.vue?vue&type=script&lang=js&"
export * from "./LixeiraTable.vue?vue&type=script&lang=js&"
import style0 from "./LixeiraTable.vue?vue&type=style&index=0&id=0824d800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824d800",
  null
  
)

export default component.exports